/**
 * Floating section list for the Manual Actions bucket.
 * Rows are multi-select: a selected row is bold with a highlighted background. "All Manual Actions"
 * (first row) selects the union of every visible section.
 */
import { observer } from "mobx-react";
import "./rma-list-manual-actions-popup.scss";
import useDashboardTranslation from "../../../../../../../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import { RmaListBucketFiltersStore } from "../../../../../../../../../rma-list-page/stores/rma-list-bucket-filters-store";
import RmaListManualActionsPopupRow from "./components/rma-list-manual-actions-popup-row/rma-list-manual-actions-popup-row";

interface IProps {
    bucketFiltersStore: RmaListBucketFiltersStore;
    getLabel: (value: string) => string;
    onToggle: (value: string) => void;
    onToggleAll: () => void;
}

const RmaListManualActionsPopup: React.FC<IProps> = observer(
    ({ bucketFiltersStore, getLabel, onToggle, onToggleAll }) => {
        const { getTranslation } = useDashboardTranslation();
        const scope = "dashboard-returns-page";

        const selected = bucketFiltersStore.selectedManualActions;
        const allSelected = bucketFiltersStore.areAllManualActionsSelected;

        return (
            <div className="rma-list-manual-actions-popup">
                <RmaListManualActionsPopupRow
                    label={getTranslation("ALL_MANUAL_ACTIONS", scope)}
                    count={bucketFiltersStore.manualActionsTotal}
                    isSelected={allSelected}
                    onToggle={onToggleAll}
                />
                {bucketFiltersStore.manualActionOptions.map((option) => (
                    <RmaListManualActionsPopupRow
                        key={option.value}
                        label={getLabel(option.value)}
                        count={option.count}
                        isSelected={selected.includes(option.value)}
                        onToggle={() => onToggle(option.value)}
                    />
                ))}
            </div>
        );
    },
);

export default RmaListManualActionsPopup;
